<script>
export default {
	name: 'BaseControl',
	methods: {
		subcommand(name, data) {
			this.$emit('subcommand', name, data);
		},
	},
};
</script>
